<template>
    <div style="padding: 5px">
        <!-- 重命名对话框 -->
        <el-dialog :visible.sync="renameDialog" width="300px" :close-on-click-modal="false" :show-close="false"
                   :modal-append-to-body="false">
            <div slot="title" class="dialogTitle">
                重命名
            </div>
            <el-form :model="renameFormData">
                <el-form-item prop="renameText" :rules="{trigger: 'blur', required: true, message: '不能重命名为空'}">
                    <el-input v-model="renameFormData.renameText" type="text" size="small" :clearable="true"></el-input>
                </el-form-item>
            </el-form>
            <el-row>
                <el-button style="float: right" type="primary" @click="commitRename" size="mini">确定</el-button>
                <el-button style="float: right;margin-right: 10px" type="primary" @click="renameDialog = false"
                           size="mini">取消
                </el-button>
            </el-row>
        </el-dialog>
        <!-- 自定义格式化对话框 -->
        <el-dialog :visible.sync="formatDialog" width="300px" :close-on-click-modal="false" :show-close="false"
                   :modal-append-to-body="false">
            <div slot="title" class="dialogTitle">
                自定义格式化
            </div>
            <el-form :model="formatFormData">
                <el-form-item prop="formatter" :rules="{trigger: 'blur', required: true, message: '格式化信息不能为空'}">
                    <el-input v-model="formatFormData.formatter" type="text" size="small" :clearable="true"></el-input>
                </el-form-item>
            </el-form>
            <el-row>
                <el-button style="float: right" type="primary" @click="commitFormat" size="mini">确定</el-button>
                <el-button style="float: right;margin-right: 10px" type="primary" @click="formatDialog = false"
                           size="mini">取消
                </el-button>
            </el-row>
        </el-dialog>
        <!-- 数据区 -->
        <!-- 过滤数据组 -->
        <el-row v-if="groupKey === 'filter'" style="border:1px #eee dashed; padding: 0px 5px 5px 5px;">
            <data-area-filter :sjj-id="sjjId" style="margin-top: 5px" :field-options="filteredFields"
                              :width="width"
                              :data.sync="groupData">
            </data-area-filter>
        </el-row>
        <!-- 通常数据组 -->
        <!-- zyfei 新增style -->
        <el-row v-else style="border:1px #eee dashed; padding: 0px 5px 5px 5px;">
            <data-area-item v-for="(item,index) in groupData" style="margin-top: 5px"
                            :width="width" :key="index"
                            :default-item-data="defaultItemData"
                            @item-select-dialog-open="fieldSelectVisible = false"
                            @remove-this="removeItem"
                            @menu-click="menuClickHandler"
                            :data.sync="groupData[index]"
                            :menu-checker="menuConfig.checker"
                            :setting-menu-list="filteredMenuList"
                            :field-options="filteredFields"
                            :xh="index">
            </data-area-item>
            <!-- 新增 -->
            <el-popover :disabled="!showAdd" v-if="showAdd || groupData.length < 1" v-model="fieldSelectVisible"
                        trigger="click" placement="left-start" width="300px">
                <!-- 新增 -->
                <template slot="reference">
                    <div class="dataAreaItemAdd" :style="{width: width + 'px'}"
                         :class="showAdd ? '' : 'add-is-disabled'">
                        <i v-if="showAdd" class="el-icon-plus"></i>
                        <span style="font-weight: normal" v-else>度量名</span>
                    </div>
                </template>
                <!-- 字段选择区 -->
                <div>
                    <!-- 字段筛选框 -->
                    <el-input v-model="fieldFilter" type="text" size="mini" suffix-icon="el-icon-search"
                              placeholder="检索字段">
                    </el-input>
                    <!-- 字段展示区 -->
                    <div style="margin-top: 15px" v-for="(value, key) in fieldsGroup" :key="key">
                        <div v-if="$comUtils.isNotEmpty(value)">
                            <div :style="{color: getColor({dataType: key === 'D' ? '2' : '1'})}" style="height: 20px;display: inline-flex;">
                                <div class="fieldTypeText">{{key === 'D' ? '度量' : ('维度')}}</div>
                                <div class="splitLine"></div>
                            </div>
                            <el-row class="fieldSelectedGroup">
                                <ul class="fieldList">
                                    <li v-for="item in value" :key="item.fieldName + item.disabled">
                                        <el-button :title="$comUtils.isEmpty(item.title) ? item.fieldName : item.title"
                                                   class="textOverflow"
                                                   :disabled="item.disabled" type="text" @click="addItem(item)">
                                            <svg-icon class="iconCommentClass" :style="{color: getColor(item)}"
                                                      :icon-class="getFieldIcon(item)"></svg-icon>
                                            <span style="margin-left: 5px">{{item.fieldAlias}}</span>
                                        </el-button>
                                    </li>
                                </ul>
                            </el-row>
                        </div>
                    </div>
                </div>
            </el-popover>
        </el-row>
    </div>
</template>

<script>
    import DataAreaItem from "./DataAreaItem";
    import DataAreaFilter from "./DataAreaFilter";
    import dataAreaCommonUtils from "../../utils/DataAreaCommonUtils"

    export default {
        name: "DataAreaGroup",
        components: {DataAreaFilter, DataAreaItem},
        props: {
            // 数据集id
            sjjId: {
                type: String,
                required: true
            },
            // 组件宽度，单位px
            width: {
                type: Number,
                default: 250
            },
            // 可选字段列表 结构{fieldName:'', fieldType: '', fieldTypeTrans: '', }
            fieldOptions: {
                type: Array,
                required: true,
            },
            // 组的唯一键
            groupKey: {
                type: String,
                required: true
            },
            // 绑定数据 .sync 进行双向绑定
            data: {
                type: Array,
            },
            // 添加新节点时的默认数据
            defaultItemData: {
                type: Function,
                required: true
            },
            // 菜单显示/禁用（根据key）
            menuConfig: {
                type: Object,
                default: function () {
                    return {
                        disabled: [], // 禁用的菜单项 数组或'ALL'
                        noVisible: [], // 不显示的菜单项 数组或'ALL'
                        // 菜单项检查器 在DataAreaItem选择的字段变更时触发
                        checker: function (menuItem, dataAreaItemData) {
                            return 1;
                        }
                    };
                }
            },
            rules: {
                type: Object,
                default: function () {
                    return {
                        // // 指定该区域可选字段类型
                        // dataType: {
                        //     value: ['1'],
                        //     message: '99999999999'
                        // },
                        // // 指定该区域数据数量范围，-1代表不限制
                        // range: {
                        //     value: [0, 2],
                        //     message: '8888888888'
                        // },
                        // // 是否允许重复选择字段
                        // fieldRepeat: {
                        //     value: false,
                        //     message: '1111111111'
                        // },
                        // // 禁用的字段 (指定字段原名)
                        // disabledField: {
                        //     value: [],
                        //     // message: 'xx已选用该字段'
                        // }
                    }
                }
            },

        },
        data: function () {
            return {
                // 重命名对话框状态
                renameDialog: false,
                // 重命名数据
                renameFormData: {
                    renameText: '',
                },
                // 格式化对话框状态
                formatDialog: false,
                // 字段选择对话框状态
                fieldSelectVisible: false,
                // 格式化数据
                formatFormData: {
                    formatter: '',
                },
                // 菜单项 clickEventName 属性失效
                settingMenuList: [
                    {
                        displayText: '求和',
                        clickEventName: 'menu-click',
                        key: 'sum',
                        value: 'SUM',
                        group: 'expression'
                    },
                    {
                        displayText: '平均值',
                        clickEventName: 'menu-click',
                        key: 'avg',
                        value: 'AVG',
                        group: 'expression'
                    },
                    {
                        displayText: '计数',
                        clickEventName: 'menu-click',
                        key: 'count',
                        value: 'COUNT',
                        group: 'expression'
                    },
                    // {
                    //     displayText: '去重计数',
                    //     clickEventName: 'menu-click',
                    //     key: 'distinctCount',
                    //     value: 'distinctCount',
                    //     group: 'expression'
                    // },
                    {
                        displayText: '无聚合',
                        clickEventName: 'menu-click',
                        children: [],
                        key: 'noExpression',
                        value: '',
                        group: 'expression'
                    },
                    {
                        displayText: '更多聚合方式',
                        clickEventName: '',
                        trigger: 'hover',
                        key: 'moreExpression',
                        value: '',
                        group: 'expression',
                        children: [
                            {
                                displayText: '最小值',
                                clickEventName: 'menu-click',
                                key: 'min',
                                value: 'MIN',
                                group: 'expression'
                            },
                            {
                                displayText: '最大值',
                                clickEventName: 'menu-click',
                                key: 'max',
                                value: 'MAX',
                                group: 'expression'
                            }
                        ]
                    },
                    {
                        key: 'splitLine-1',
                        needDL: true
                    },
                    {
                        displayText: '格式化',
                        clickEventName: '',
                        trigger: 'hover',
                        children: [
                            {
                                displayText: '保留两位小数',
                                clickEventName: 'menu-click',
                                children: [],
                                key: '2',
                                value: '###,###,###,###,##0.00',
                                group: 'formatter'
                            },
                            {
                                displayText: '保留一位小数',
                                clickEventName: 'menu-click',
                                children: [],
                                key: '1',
                                value: '###,###,###,###,##0.0',
                                group: 'formatter'
                            },
                            {
                                displayText: '整数',
                                clickEventName: 'menu-click',
                                children: [],
                                key: '0',
                                value: '###,###,###,###,##0',
                                group: 'formatter'
                            },{
                                displayText: '无格式',
                                clickEventName: 'menu-click',
                                children: [],
                                key: 'noFormat',
                                value: '',
                                group: 'formatter'
                            },{
                                displayText: '自定义',
                                clickEventName: 'menu-click',
                                children: [],
                                key: 'custom',
                                value: '',
                                group: 'formatter'
                            },{
                                displayText: 'yyyy-MM-dd',
                                clickEventName: 'menu-click',
                                children: [],
                                key: 'date1',
                                value: 'yyyy-MM-dd',
                                group: 'formatter'
                            },{
                                displayText: 'yyyy-MM-dd HH:mm:ss',
                                clickEventName: 'menu-click',
                                children: [],
                                key: 'date2',
                                value: 'yyyy-MM-dd HH:mm:ss',
                                group: 'formatter'
                            },{
                                displayText: 'yyyy/MM/dd',
                                clickEventName: 'menu-click',
                                children: [],
                                key: 'date3',
                                value: 'yyyy/MM/dd',
                                group: 'formatter'
                            },{
                                displayText: 'yyyy/MM/dd HH:mm:ss',
                                clickEventName: 'menu-click',
                                children: [],
                                key: 'date4',
                                value: '',
                                group: 'formatter'
                            },
                        ],
                        key: 'format',
                        value: 'format',
                        group: 'formatter'
                    },
                    {
                        displayText: '重命名',
                        clickEventName: 'menu-click',
                        children: [],
                        key: 'rename',
                        group: 'fieldNameRename'
                    },
                    {
                        displayText: '排序',
                        clickEventName: '',
                        trigger: 'hover',
                        children: [
                            {
                                displayText: '正序',
                                clickEventName: 'menu-click',
                                children: [],
                                key: 'asc',
                                value: 'ASC',
                                group: 'order'
                            },
                            {
                                displayText: '倒序',
                                clickEventName: 'menu-click',
                                children: [],
                                key: 'desc',
                                value: 'DESC',
                                group: 'order'
                            },
                            {
                                displayText: '无序',
                                clickEventName: 'menu-click',
                                children: [],
                                key: 'noOrder',
                                value: '',
                                group: 'order'
                            }
                        ],
                        key: 'order',
                        group: 'order'
                    },
                    {
                        key: 'splitLine-2',
                        needDL: true
                    },
                    {
                        displayText: '上移',
                        clickEventName: 'menu-click',
                        children: [],
                        key: 'up',
                        value: 'up',
                        group: 'move'
                    },
                    {
                        displayText: '下移',
                        clickEventName: 'menu-click',
                        children: [],
                        key: 'down',
                        value: 'down',
                        group: 'move'
                    }
                ],
                // 组内数据校验结果
                dataValidatorResult: {},
                // 字段筛选
                fieldFilter: '',
                // 当前操作的组件数据
                targetDataAreaItem: {},
                // 组件回传数据
                groupData: [
                    // {
                    //     "expression": {"displayText": "最小值", "value": "min"},
                    //     "formatter": {"displayText": "保留一位小数", "value": "###,###,###,###,##0.0"},
                    //     "fieldNameOrigin": "测试字段1",
                    //     "fieldNameRename": "测试字段1",
                    //     "order": {"displayText": "倒序", "value": "desc"},
                    //     "BLA": "bar",
                    //     "fieldData": {"fieldName": "测试字段1", "fieldTypeTrans": 3},
                    //     "xh": 0
                    // },
                    // {
                    //     "expression": {"displayText": "最小值", "value": "min"},
                    //     "formatter": {"displayText": "保留一位小数", "value": "###,###,###,###,##0.0"},
                    //     "fieldNameOrigin": "测试字段2",
                    //     "fieldNameRename": "测试字段2",
                    //     "order": {"displayText": "倒序", "value": "desc"},
                    //     "BLA": "bar",
                    //     "fieldData": {"fieldName": "测试字段1", "fieldTypeTrans": 3},
                    //     "xh": 1
                    // }
                ],
            }
        },
        methods: {
            // 打开重命名
            openRename: function (menuData, xh, itemData) {
                this.renameDialog = true;
                this.renameFormData.renameText = this.groupData[xh].fieldNameRename;
                this.targetDataAreaItem = this.groupData[xh];
            },
            // 提交重命名
            commitRename: function () {
                this.renameDialog = false;
                this.targetDataAreaItem.fieldNameRename = this.renameFormData.renameText;
                // 通知图表组件更新
                this.$parent.$emit('resetChart', 'rename');
            },
            // 打开格式化
            openFormat: function (menuData, xh, itemData) {
                this.formatDialog = true;
                this.formatFormData.formatter = this.groupData[xh].formatter.value;
                this.targetDataAreaItem = this.groupData[xh];
            },
            // 提交格式化
            commitFormat: function () {
                this.targetDataAreaItem.formatter.value = this.formatFormData.formatter;
                this.targetDataAreaItem.formatter.displayText = '自定义';
                this.formatDialog = false;
                this.$parent.$emit('resetChart', 'format');
            },
            // 移除一个数据区选项
            removeItem: function (xh, data) {
                let remove = this.groupData.splice(xh, 1);
            },
            // 添加一个数据区选项
            addItem: function (item) {
                let range = this.computedRules.range.value;
                let length = this.groupData.length;
                if (range[1] >= 0 && length >= range[1]) {
                    this.$message.warning(this.computedRules.range.message);
                    return;
                }
                let add = this.defaultItemData(item);
                add.fieldNameOrigin = item.fieldName;
                add.fieldNameRename = '';
                // if (this.$comUtils.isEmpty(add.expression.displayText)) {
                //     add.fieldNameRename = item.fieldAlias;
                // } else {
                //     add.fieldNameRename = item.fieldAlias + '(' + add.expression.displayText + ')';
                // }
                add.fieldData = item;
                this.groupData.push(add);
                this.fieldSelectVisible = false;
            },
            // 树的迭代器
            iterator: function (array, handler) {
                if (this.$comUtils.isEmpty(array)) {
                    return;
                }
                for (let i = 0; i < array.length; i++) {
                    handler(array[i]);
                    this.iterator(array[i].children, handler);
                }
            },
            // 菜单选项点击处理 参数：菜单项数据，菜单项的父菜单项数组，组件序号，组件数据
            menuClickHandler: function (menuData, parent, xh, data) {
                console.log(menuData, parent, xh, data);
                // 找到数组中的对应菜单项（因为参数中的数据是计算过的）
                let findMenu = this.findMenu([...parent, menuData], undefined, this.filteredMenuList, 0);
                if (this.$comUtils.isEmpty(findMenu)) {
                    console.log('无选项')
                    return;
                }
                if (findMenu.group === 'fieldNameRename') {
                    // console.log('重命名！');
                    this.openRename(menuData, xh, data);
                } else if (findMenu.group === 'formatter' && findMenu.key === 'custom') {
                    this.openFormat(menuData, xh, data);
                } else if (findMenu.group === 'move') {
                    let move;
                    if (findMenu.key === 'up') {
                        if (xh === 0) {
                            this.$message.warning('已到顶部');
                            return;
                        }
                        move = this.groupData.splice(xh, 1)[0];
                        this.groupData.splice(xh - 1, 0, move);
                    } else {
                        if (xh >= this.groupData.length - 1) {
                            this.$message.warning('已到末尾');
                            return;
                        }
                        move = this.groupData.splice(xh, 1)[0];
                        this.groupData.splice(xh + 1, 0, move);
                    }
                } else {
                    this.targetDataAreaItem = this.groupData[xh];
                    this.targetDataAreaItem[findMenu.group] = {displayText: findMenu.displayText, value: findMenu.value};
                    if (findMenu.group === 'expression') {
                        this.targetDataAreaItem.fieldNameRename = this.targetDataAreaItem.fieldNameOrigin + '(' + findMenu.displayText + ')';
                    }
                }
            },
            // 找到点击的菜单项的配置
            findMenu: function (targetLevelList, parent, array, index) {
                if (index >= targetLevelList.length) {
                    return parent;
                }
                for (let i = 0; i < array.length; i++) {
                    if (array[i].displayText === targetLevelList[index].displayText) {
                        return this.findMenu(targetLevelList, array[i], array[i].children, index + 1);
                    }
                }
                return undefined;
            },
            // 获取字段图标
            getFieldIcon: function (item) {
                return dataAreaCommonUtils.getFieldIcon(item)
            },
            /** 获取字体+图标颜色 */
            getColor: function (item) {
                return dataAreaCommonUtils.getColor(item)
            },
            // 数据校验器
            dataValidator: function (data) {
                let res = {
                    result: false,
                    message: '',
                }
                // 数量校验
                let range = this.computedRules.range.value;
                if (range[0] >= 0 && data.length < range[0]) {
                    res.message = this.computedRules.range.message;
                    return res;
                }
                if (range[1] >= 0 && data.length > range[1]) {
                    res.message = this.computedRules.range.message;
                    return res;
                }
                // 重复校验
                let fieldRepeat = this.computedRules.fieldRepeat.value;
                if (!fieldRepeat) {
                    let map = {};
                    for (let i = 0; i < data.length; i++) {
                        let item = data[i];
                        if (this.$comUtils.isNotEmpty(map[item.fieldNameOrigin])) {
                            // this.$message.warning(this.computedRules.fieldRepeat.message);
                            res.message = this.computedRules.fieldRepeat.message;
                            return res;
                        }
                    }
                }
                // 类型校验
                let dataType = this.computedRules.dataType.value;
                for (let i = 0; i < data.length; i++) {
                    let item = data[i];
                    if (this.$comUtils.isNotEmpty(item.fieldData) && dataType.indexOf(item.fieldData.dataType) < 0) {
                        // this.$message.warning(this.computedRules.dataType.message);
                        res.message = this.computedRules.dataType.message;
                        return res;
                    }
                }
                res.result = true;
                res.message = '通过';
                return res;
            },
            // 更新dataValidatorResult
            setDataValidatorResultTimer: function (val) {
                this.dataValidatorResult = val;
            }
        },
        computed: {
            // 对字段进行过滤
            filteredFields: function () {
                let res = [];
                let ori = jQuery.extend(true, [], this.fieldOptions);
                for (let i = 0; i < ori.length; i++) {
                    let item = ori[i];
                    if (item.isqy === '0') {continue;}
                    // 禁用已选字段
                    item.disabled = !this.computedRules.fieldRepeat.value && this.selectedFields.indexOf(item.fieldName) >= 0;
                    // 禁用类型不符合的字段
                    item.disabled = item.disabled || this.computedRules.dataType.value.indexOf(item.dataType) < 0;
                    // 禁用禁用字段
                    if (!item.disabled && this.$comUtils.isNotEmpty(this.computedRules.disabledField.value)) {
                        item.disabled = this.computedRules.disabledField.value.indexOf(item.fieldName) >= 0;
                        if (item.disabled) {
                            item.title = this.$comUtils.isEmpty(this.computedRules.disabledField.message) ? undefined : this.computedRules.disabledField.message;
                        }
                    }
                    res.push(item);
                }
                return res;
            },
            // 对字段进行分组
            fieldsGroup: function () {
                let assist = ['', 'W', 'D'];
                let obj = {
                    W: [],
                    D: [],
                }
                for (let i = 0; i < this.filteredFields.length; i++) {
                    let item = this.filteredFields[i];
                    if (this.$comUtils.isNotEmpty(this.fieldFilter)) {
                        if (item.fieldAlias.includes(this.fieldFilter)) {
                            obj[assist[parseInt(item.dataType)]].push(item);
                        }
                    } else {
                        obj[assist[parseInt(item.dataType)]].push(item);
                    }
                }
                return obj;
            },
            // 已被选择的字段
            selectedFields: function () {
                let data = this.groupData;
                let res = [];
                for (let i = 0; i < data.length; i++) {
                    res.push(data[i].fieldNameOrigin);
                }
                return res;
            },
            // 过滤菜单项
            filteredMenuList: function () {
                let res = jQuery.extend(true, [], this.settingMenuList);
                this.iterator(res, (item) => {
                    // 检查是否显示
                    if (this.$comUtils.isNotEmpty(this.menuConfig.noVisible)) {
                        let noVisible = this.menuConfig.noVisible;
                        if (Array.isArray(noVisible)) {
                            item.visible = noVisible.indexOf(item.key) < 0;
                        } else {
                            item.visible = noVisible.toUpperCase() !== 'ALL';
                        }
                    }
                    // 检查是否禁用
                    if (this.$comUtils.isNotEmpty(this.menuConfig.disabled)) {
                        let disabled = this.menuConfig.disabled;
                        if (Array.isArray(disabled)) {
                            item.disabled = disabled.indexOf(item.key) >= 0;
                        } else {
                            item.disabled = disabled.toUpperCase() === 'ALL';
                        }
                    }
                })
                return res;
            },
            // 设置默认规则
            computedRules: function () {
                let defaultRules = {
                    // 指定该区域可选字段类型
                    dataType: {
                        value: ['1', '2'],
                        message: ''
                    },
                    // 指定该区域数据数量范围，-1代表不限制
                    range: {
                        value: [-1, -1],
                        message: ''
                    },
                    // 是否允许重复选择字段
                    fieldRepeat: {
                        value: true,
                        message: ''
                    },
                    // 禁用的字段 (指定字段原名)
                    disabledField: {
                        value: [],
                        message: '',
                    }
                }
                let res = jQuery.extend(true, {}, this.rules);
                let keys = Object.keys(defaultRules);
                for (let i = 0; i < keys.length; i++) {
                    if (this.$comUtils.isEmpty(res[keys[i]])) {
                        res[keys[i]] = defaultRules[keys[i]];
                    } else if (this.$comUtils.isEmpty(res[keys[i]].value)) {
                        res[keys[i]].value = defaultRules[keys[i]].value;
                    }
                }
                return res;
            },
            // 是否显示添加
            showAdd: function () {
                let range = this.computedRules.range.value;
                let length = this.groupData.length;
                return !(range[1] >= 0 && length >= range[1]);
            },
        },
        watch: {
            groupData: {
                handler: function (nv, ov) {
                    this.$emit('update:data', nv);
                    let res = this.dataValidator(nv);
                    this.setDataValidatorResultTimer(res);
                    // console.log('组数据更新', nv);
                },
                deep: true,
            },
            rules: {
                handler: function (nv, ov) {
                    let res = this.dataValidator(this.groupData);
                    this.setDataValidatorResultTimer(res);
                }
            },
            data: {
                handler: function (nv, ov) {
                    this.groupData = nv;
                },
                deep: true,
            },
            dataValidatorResult: {
                handler: function (nv, ov) {
                    this.$emit('validateResultChange', nv, this.groupKey);
                },
                deep: true
            },
            // 保证字段选择框单例
            fieldSelectVisible: function (nv, ov) {
                if (nv) {
                    this.$root.$emit('closeOther', this.groupKey);
                }
            }
        },
        mounted() {
            let context = this;
            document.body.onclick = () => {
                context.$root.$emit('clickBlank');
            }
            this.groupData = this.data;

            this.$root.$on('closeOther', (key) => {
                if (this.groupKey !== key) {
                    this.fieldSelectVisible = false;
                }
            });
        }
    }
</script>

<style scoped>
    .selected .el-button--text {
        color: #1a73e8;
    }

    .dataAreaItemAdd {
        /* border: 1px solid black !important; */
        /* width: 160px; */
        height: 25px;
        margin-top: 5px;
        text-align: center;
        font-size: 18px;
        line-height: 25px;
        cursor: pointer;
        outline-width: 0px !important;
        font-weight: bolder;
        /* zyfei增加style */
        border: 1px solid #c0c4cc !important;
        border-radius: 2px;
        width: 100%;
        /* zyfei增加style---end */
    }

    .add-is-disabled {
        background-color: #9c9c9c !important;
        cursor: no-drop;
    }

    .dataAreaItemAdd:hover {
        background-color: rgba(160, 207, 255, 0.5);
    }

    .dialogTitle {
        width: 100%;
        font-size: 20px;
        text-align: center;
    }

    .iconCommentClass {
        font-size: 18px !important;
        line-height: 25px !important;
        width: 1em !important;
        height: 1em !important;
    }

    .fieldList li .el-button {
        width: 100%;
        color: black;
        text-align: left;
        padding: 5px 5px;
        /* font-size: 15px; */
        max-width: 200px;
        /* font-weight: 600; */

        /* zyfei增加style */
        font-size: 13px;
    }

    .fieldList li .el-button--text:hover {
        background-color: rgba(156, 156, 156, 0.42);
    }

    .fieldList li .is-disabled:hover {
        background-color: unset !important;
    }

    .fieldList li .is-disabled {
        color: #9c9c9c !important;
    }

    .fieldList li.selected .el-button--text {
        color: #1a73e8;
    }

    .textOverflow {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    ::v-deep .el-divider--horizontal {
        margin-bottom: 10px;
        margin-top: 10px;
    }

    ::v-deep .el-divider__text {
        /* font-size: 17px; */
        font-weight: bold;
        /* color: #e812a2; */
        /* zyfei增加style */
        font-size: 15px;
    }

    .splitLine {
        width: 3px;
        background-color: #c955c0;
        height: 100%;
        margin-left: 10px;
        display: inline-block;
    }

    .fieldTypeText {
        height: 100%;
        line-height: 20px;
        font-weight: bold;
    }
</style>
